module.exports = __webpack_public_path__ + "img/alloy.6b22a20.jpg";